import { Cities } from "../modules/cities";

export const CitiesPage = () => {
  return <Cities />;
};
